import { MatchMedia } from '@helvetia/components/MatchMedia'
import Stepper from '@helvetia/components/Stepper'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { redirectionProvider } from './CalculatorRedirection.provider'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface Props {
  step: number
}

const CalculatorStepperRaw: React.SFC<
  Props & RouteComponentProps & WithNamespaces
> = ({ history, step, t }) => {
  return (
    <MatchMedia tablet>
      <Stepper
        currentStep={step}
        steps={[
          { stepNumber: 1, labelText: t('stepper.step1') },
          { stepNumber: 2, labelText: t('stepper.step2') },
          { stepNumber: 3, labelText: t('stepper.step3') },
          { stepNumber: 4, labelText: t('stepper.step4') },
          { stepNumber: 5, labelText: t('stepper.step5') },
          { stepNumber: 6, labelText: t('stepper.step6') },
        ]}
        onClick={(stepNumber: number) => {
          history.push(redirectionProvider.redirectToStep(stepNumber))
        }}
      />
    </MatchMedia>
  )
}

export const CalculatorStepper = withNamespaces()(
  withRouter(CalculatorStepperRaw),
)
